import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles((theme: any) => ({
  // ── Dialog structure ─────────────────────────────────────────────
  dialogPaper: {
    height: "78vh",
    maxHeight: "78vh",
    width: "1100px",
    maxWidth: "1100px",
    display: "flex",
    flexDirection: "column",
  },
  dialogTitle: {
    borderBottom: "1px solid #d5d2d5",
    backgroundColor: "#f6f6f7",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  titleSerial: {
    fontFamily: "monospace",
    color: `${theme.palette.text.secondary} !important`,
    fontSize: "13px !important",
    marginLeft: "8px !important",
  },
  dialogContent: {
    padding: "0 !important",
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
    flex: 1,
  },
  dialogActions: {
    backgroundColor: "#f6f6f7",
    borderTop: "1px solid #d5d2d5",
    padding: "8px 16px !important",
  },

  // ── Side nav ─────────────────────────────────────────────────────
  sideNav: {
    width: 190,
    borderRight: "1px solid rgba(0,0,0,0.08)",
    flexShrink: 0,
    overflow: "auto",
    backgroundColor: "rgba(0,0,0,0.018)",
  },
  navSectionLabel: {
    padding: "14px 16px 4px",
    fontSize: "10px",
    fontWeight: 700,
    color: "rgba(0,0,0,0.38)",
    letterSpacing: "0.1em",
    textTransform: "uppercase" as any,
  },
  navList: {
    paddingLeft: "6px !important",
    paddingRight: "6px !important",
  },
  navItemCache: {
    borderRadius: "6px !important",
    paddingTop: "7px !important",
    paddingBottom: "7px !important",
    marginBottom: "2px !important",
  },
  navItem: {
    borderRadius: "6px !important",
    paddingTop: "7px !important",
    paddingBottom: "7px !important",
  },
  navItemIcon: {
    minWidth: "30px !important",
  },
  navIcon: {
    fontSize: "16px !important",
  },
  navItemText: {
    fontSize: "13px",
  },

  // ── Right panel ──────────────────────────────────────────────────
  rightPanel: {
    flex: 1,
    overflowY: "scroll" as any,
    paddingBottom: 24,
  },

  // ── Shared panel ─────────────────────────────────────────────────
  panelPadding: {
    padding: "20px 24px",
  },
  panelHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  panelTitle: {
    fontWeight: "600 !important",
    fontSize: "14px !important",
  },

  // ── Empty / loading states ───────────────────────────────────────
  emptyState: {
    display: "flex",
    flexDirection: "column" as any,
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    gap: 8,
    userSelect: "none" as any,
  },
  emptyStateIcon: {
    fontSize: "36px !important",
  },
  emptyStateText: {
    color: `${theme.palette.text.disabled} !important`,
    fontSize: "12px !important",
  },
  loadingState: {
    display: "flex",
    flexDirection: "column" as any,
    alignItems: "center",
    gap: 10,
    paddingTop: 48,
    color: "rgba(0,0,0,0.35)",
  },
  emptyDataState: {
    display: "flex",
    flexDirection: "column" as any,
    alignItems: "center",
    gap: 8,
    paddingTop: 48,
  },
  emptyDataIcon: {
    fontSize: "32px !important",
  },
  smallText: {
    fontSize: "12px !important",
  },

  // ── Cache data view ──────────────────────────────────────────────
  summaryChips: {
    display: "flex",
    gap: 6,
    marginBottom: 14,
  },
  summaryChipItem: {
    fontSize: "11px !important",
    height: "22px !important",
  },
  lineList: {
    display: "flex",
    flexDirection: "column" as any,
    gap: 6,
  },
  lineRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "8px 12px",
    backgroundColor: "rgba(0,0,0,0.025)",
    borderRadius: 6,
    border: "1px solid rgba(0,0,0,0.07)",
  },
  lineLabel: {
    fontSize: "11px !important",
    fontWeight: "700 !important",
    fontFamily: "monospace !important",
    minWidth: "52px !important",
    letterSpacing: "0.03em !important",
  },
  chipRow: {
    display: "flex",
    gap: 5,
    flexWrap: "wrap" as any,
  },
  chipWrapper: {
    display: "inline-flex",
  },
  handlerChip: {
    fontFamily: "monospace !important",
    fontSize: "11px !important",
    height: "22px !important",
  },
  emptyHandlerChip: {
    opacity: "0.45 !important",
    borderStyle: "dashed !important",
  },
  cacheDivider: {
    margin: "16px 0 !important",
  },
  jsonToolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  jsonToggleBtn: {
    textTransform: "none !important" as any,
    color: `${theme.palette.text.secondary} !important`,
    fontSize: "13px !important",
  },
  expandIcon: {
    fontSize: "20px !important",
  },
  iconGroup: {
    display: "flex",
    gap: 2,
  },
  actionIcon: {
    fontSize: "18px !important",
  },
  refreshIcon: {
    fontSize: "20px !important",
  },
  cacheDataPre: {
    backgroundColor: "#1e1e1e",
    color: "#d4d4d4",
    padding: "12px",
    borderRadius: "4px",
    fontSize: "11px",
    lineHeight: 1.5,
    overflow: "auto",
    fontFamily: "monospace",
    whiteSpace: "pre-wrap" as any,
    wordBreak: "break-word" as any,
    marginTop: 8,
    height: "320px",
    maxHeight: "320px",
  },

  // ── Clear cache ──────────────────────────────────────────────────
  clearTitle: {
    fontWeight: "600 !important",
    fontSize: "14px !important",
    marginBottom: "4px !important",
  },
  clearSubtext: {
    marginBottom: "20px !important",
  },
  clearRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  clearLineSelect: {
    width: "auto",
    margin: 0,
    padding: "6px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid rgba(0,0,0,0.23)",
  },
  clearBtn: {
    whiteSpace: "nowrap !important" as any,
  },
  confirmBox: {
    marginTop: 14,
    padding: "14px 16px",
    backgroundColor: "rgba(211,47,47,0.05)",
    borderRadius: 6,
    border: "1px solid rgba(211,47,47,0.18)",
  },
  confirmText: {
    marginBottom: "12px !important",
    fontSize: "13px !important",
  },
  confirmActions: {
    display: "flex",
    gap: 8,
  },
}));

export default useStyles;
